<div class="layout-ParentDiv innerDiv UserRedemptionPage">
  <div class="layout-dashboard" [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
      <p-toast key="toastmsg"></p-toast>
      <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
        <div class="mainDivHeader">
          <div class="leftdiv">
            <h4>User Redemption Request List<span class="badge">{{ totalRecords }}</span></h4>
          </div>
          <div class="rightDiv">
            <button class="exportBTn" (click)="exportExcel()"> <span><img
                  src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
              Export</button>
          </div>
        </div>      
        <div class="mainDivBody">
          <div class="date-filterDiv">
            <ul class="filtersList">
              <li>
                  <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                    optionLabel="label"></p-dropdown>
              </li>
              <li>
                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                  class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
              </li>
              <li>
                <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                  class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
              </li>
              <li>
                <button (click)="loadWallet($event)" class="searchFilterBtn">
                  <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                </button>
              </li>
              <li>
                <button (click)="clear()" class="clearFilterBtn">
                  <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                  <span>Clear All</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="maintableDiv">
            <div class="tableParanet">
              <p-table class="expandable" #dt [value]="walletlist" [autoLayout]="true" [paginator]="true" [rows]="10"
                [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both" (onLazyLoad)="loadWallet($event)"
                [totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="paginationOption"
                styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th pfrozencolumn="" class="userNameTD" style="left: 0px"
                      pSortableColumn="fullName">
                      <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="fullName"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="created_at" class="userdateTD">
                      <div class="p-d-flex p-jc-between p-ai-center"> Date <p-sortIcon field="created_at"></p-sortIcon>
                      </div>
                    </th>
                    <th class="transferAmountTD" pSortableColumn="transferAmount">
                      <div class="p-d-flex p-jc-between p-ai-center"> Amount <p-sortIcon field="transferAmount"></p-sortIcon>
                      </div>
                    </th>
                    <th class="tdsTD" pSortableColumn="tds">
                      <div class="p-d-flex p-jc-between p-ai-center"> TDS <p-sortIcon field="tds"></p-sortIcon>
                      </div>
                    </th>
                    <th class="transferCreditTD" pSortableColumn="totalCreditedAmount">
                      <div class="p-d-flex p-jc-between p-ai-center"> Transferable Amount <p-sortIcon
                          field="totalCreditedAmount"></p-sortIcon>
                      </div>
                    </th>
                    <th class="BankDteailsTD" pSortableColumn="bankName show-col " [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                      <div class="p-d-flex p-jc-between p-ai-center"> Bank Details <p-sortIcon field="bankName"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="status" class="statusTd">
                      <div class="p-d-flex p-jc-between p-ai-center"> Status <p-sortIcon field="status"></p-sortIcon>
                      </div>
                    </th>
                    <th class="sorting_disabled action-button-td p-frozen-column" rowspan="1" colspan="1" style="justify-content: center;">
                      <div>Action</div>
                    </th>
                  </tr>
                  <tr>
                    <th [ngSwitch]="userName" pfrozencolumn="" class="userNameTD" style="left: 0px">
                      <input pInputText type="text"
                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                        [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                    </th>
                    <th [ngSwitch]="created_at" class="userdateTD">
                    </th>
                    <th [ngSwitch]="transferAmount"  class="p-element   text-nowrap transferAmountTD"  style="left: 0px">
                      <input pInputText type="text" (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains')" [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " />
                    </th>
                    <th [ngSwitch]="tds" pfrozencolumn="" class="tdsTD" style="left: 0px">
                      <input pInputText type="text" (keyup.enter)="
                            setDownloadFlag();
                            dt.filter($event.target.value, 'tds', 'contains')
                          " [value]="dt.filters['tds'] ? dt.filters['tds'].value : ''" />
                    </th>
                    <th [ngSwitch]="totalCreditedAmount"  class="p-element   text-nowrap transferCreditTD"
                      style="left: 0px">
                      <input pInputText type="text" (keyup.enter)="
                            setDownloadFlag();
                            dt.filter($event.target.value, 'totalCreditedAmount', 'contains') " [value]=" dt.filters['totalCreditedAmount']
                              ? dt.filters['totalCreditedAmount'].value : '' " />
                    </th>
                    <th [ngSwitch]="bankName "  class=" BankDteailsTD" style="left: 0px" [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                      <input pInputText type="text" (keyup.enter)="
                            setDownloadFlag();
                            dt.filter($event.target.value, 'bankName', 'contains')"
                        [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" />
                    </th>
                    <th [ngSwitch]="status" class="statusTd">
                      <p-dropdown appendTo="body" #pDropDownId [options]="statuses"
                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')" placeholder="Select Status"
                        [showClear]="true">
                        <ng-template let-option pTemplate="item">
                          <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </th>
                    <th  pfrozencolumn="" class=" show-button-main p-element text-nowrap action-button-td p-frozen-column " style="left: 0px;background: #fefef6 !important; ">
                      <div class="action-button-td-btn">
                        <button pButton pRipple label="Columns" icon="pi pi-plus" label="Columns"
                        [ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded approvebtn' : 'hide-col p-button-secondary p-button-rounded'"
                        (click)="setDownloadFlag(); addColumns()"></button>
                      <button class="closebtn" pButton pRipple label="Columns" icon="pi pi-minus" label="Columns"
                        [ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
                        (click)="setDownloadFlag(); removeColumns()"></button>
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-walletlist>
                  <tr class="p-selectable-row">
                    <td pfrozencolumn="" class="userNameTD"
                      style="left: 0px; z-index: 1001; display: flex">
                      {{ walletlist.createduserdata[0].fullName }}
                    </td>
                    <td class="userdateTD">
                      {{ walletlist.created_at | date : "dd/MM/yyyy" }}
                    </td>
                    <td class="transferAmountTD">
                      {{ walletlist.transferAmount | currency : "INR" }}
                    </td>
                    <td class="tdsTD">
                      {{ walletlist.tds | currency : "INR" }}
                    </td>
                    <td class="transferCreditTD">
                      {{ walletlist.totalCreditedAmount | currency : "INR" }}
                    </td>
                    <td class="BankDteailsTD"  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                      <div class="bankDetails">
                        <ul>
                          <li>
                              <span><b>Bank Name:</b> {{ walletlist?.kycData[0]?.bankName }}</span> 
                          </li>
                          <li>
                            <span><b>A/C Number:</b> {{ walletlist?.kycData[0]?.bankAccountNumber }}</span> 
                          </li>
                          <li>
                            <span><b>IFSC:</b> {{ walletlist?.kycData[0]?.ifsc }}</span>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td class="status-Td statusTd">
                      <p-tag [ngClass]="getClassOf(walletlist.status)" value=" {{ walletlist.status }}" [rounded]="true">
                      </p-tag>
                    </td>
                    <td class="action-button-td p-frozen-column" pfrozencolumn="" >
                      <div class="status-button w-100" *ngIf="walletlist.status == 'Pending'">
                        <ul>
                          <li>
                            <button class="approveBtn" (click)="showPaymentmodal(walletlist.id,walletlist)" pTooltip="Approved " tooltipPosition="bottom">
                              <img src="../../../assets/images/backend-image/common-images/approveBtn.svg" alt="">
                            </button>
                            <button class="rejectBtn" (click)="showPaymentrejectmodal(walletlist.id,walletlist)" pTooltip="Reject" tooltipPosition="bottom">
                              <img src="../../../assets/images/backend-image/common-images/reject--Btn.svg" alt="">
                            </button>
                          </li>
                        </ul> 
                      </div>
                      <div class="status-buttons w-100" *ngIf="walletlist.status == 'Approved'">
                        <button class="btn btn-primary w-100 viewbtn" (click)="showPaymentmodal(walletlist.id,'view')"> <i class="pi pi-eye "></i></button>
                      </div>
                      <div class="status-buttons w-100" *ngIf="walletlist.status == 'Rejected'">
                        <button class="btn btn-secondary w-100 reasonbtn" (click)="showPaymentrejectmodal(walletlist.id,'view')"> <i class="pi pi-question-circle"></i></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="7">Redemption request list not found.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>  
<p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
<p-dialog header="Payment Approve" [(visible)]="paymentType" [modal]="true" [style]="{ width: '400px' }"
  [draggable]="false" [resizable]="false" id="approveRejectModal" (onHide)="onPaymentmodalModalClose()">
  <form [formGroup]="approveUpdateForm">
    <div class="p-grid">
      <div class="col-12 mb-3">
        <label class="popUp_label" for="comment">Select Payment Method<span class="colorred">*</span></label>
        <div class="form-div">
          <p-dropdown formControlName="paymentMethod" [options]="methods" [(ngModel)]="selectedMethod" placeholder="Select Payment Method"
            optionLabel="name" appendTo="body" [filter]="true">
          </p-dropdown>
        </div>
        <div *ngIf="submitted && f.paymentMethod.status=='INVALID'"  style="margin-top: 5px;">
          <div class="colorred">Payment Method is required</div>
      </div>
      </div>     
      <div class="col-12 mb-3">
        <label class="popUp_label"  *ngIf="!dataPresent">
           Payment Image
        </label>
        <label  class="popUp_label" *ngIf="dataPresent">
           Payment Image
        </label>
        <div class="form-div"  *ngIf="!showProfile && dataPresent ">
          <p-fileUpload name="myfiles[]" cancelLabel="Cancel" accept="image/*" maxFileSize="1000000" auto="auto"
            customUpload="true" (uploadHandler)="picUploader($event)" (onRemove)="removeFile($event)">
          </p-fileUpload>
        </div>
            <div *ngIf="showProfile">
          <div class="pan-image" (click)="openHightlightImage();">
            <img src="{{imageProfile}}" [alt]="loading" width="300" class="shadow-4" />
          </div>
          <div class="button-div" (click)="openHightlightImage();">
            <button pButton pRipple type="button" icon="pi pi-eye" class="p-button-rounded"></button>
            <p>View Image</p>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <label class="popUp_label" for="comment">
          Comment
        </label>
        <div class="form-div">
          <textarea inputId="textarea" pInputTextarea rows="4" class="form-control"
            formControlName="comment"></textarea>
        </div>
      </div>
       <div class="col-12 footer-forms"  *ngIf="dataPresent">
          <button class="btn cancel-btn" (click)="onPaymentmodalModalClose()"> Cancel </button>
          <button class="btn rejectBtn" (click)="approveuser()" type="submit"> Approve </button> 
      </div> 
    </div>
  </form>
</p-dialog>
<p-dialog header="Payment Reject" [(visible)]="paymentReject" [modal]="true" [style]="{ width: '400px' }"
  [draggable]="false" [resizable]="false"  id="rejectModal"  (onHide)="onPaymentmodalModalClose()">
  <form [formGroup]="rejectUpdateForm">
    <div class="p-grid">
      <div class="col-12">
        <label for="comment">
          Add Reason <span class="mandatory-fields  colorred" >*</span>
        </label>
        <div class="form-div">
          <textarea pInputTextarea rows="5" formControlName="comment"></textarea>
        </div>
        <div *ngIf="rsubmitted && h.comment.status=='INVALID'" >
          <div class="colorred">Comment is required</div>
        </div>     
      </div>
      <div class="col-12 footer-forms"  *ngIf="dataPresent">
        <button class="btn cancel-btn" (click)="onPaymentmodalModalClose()"> Cancel </button>
        <button class="btn rejectBtn" (click)="rejectuser()" type="submit"> Reject </button> 
      </div>
    </div>
  </form>
</p-dialog>
<p-galleria [(value)]="walletlist" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
  [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
  [showItemNavigators]="false" [showThumbnails]="false">
  <ng-template pTemplate="item" let-walletlist>
    <img [src]=showHighlightImg [alt]="" style="width: 100%; display: block;" />
  </ng-template>
</p-galleria>